export function LoadingLine() {
  return (
    <div className="col s12">
      <div className="progress" style={{ margin: '0px' }}>
        <div className="indeterminate" />
      </div>
    </div>
  );
}
